import { useGameContext } from "./Hook/GameContext";
import { GamePage } from "./Hook/useGame";
import { GameHeaderWrapper } from "./Style/GameStyles";
import "./index.scss";
import { isApp } from "../../../hooks/useNativeApp";
import { useRecoilValue } from "recoil";
import { insetState } from "../../../recoil/inset";
export const GameHeader = () => {
  const imageUrl = "/image-web/game/";
  const tierUrl = imageUrl + "tier/";
  const {
    user,
    userTicketInfo,
    tier,
    openCouponDialog,
    code,
    setCode,
    setGamePageState,
  } = useGameContext();
  const inset = useRecoilValue(insetState);
  return (
    <GameHeaderWrapper className="fix-centered" isApp={inset}>
      <div className="tier-nick">
        <div className="profile">
          <img
            src={user?.profileImageUrl || "/image-web/game/game-profile.png"}
          />
        </div>
        <div className="info-wrapper">
          <div className="nickname">{user?.nickname}</div>
          <div className="line" />
          <div className="game-point">
            <img alt="아이콘" src={`/image-web/game/gp-profile.svg`} />
            <span>{userTicketInfo?.user.point.toLocaleString()} GP</span>
          </div>
        </div>
      </div>
      <div className="button-wrapper">
        <div
          className="button"
          onClick={() => {
            openCouponDialog({
              onConfirm: () => {
                alert(code);
              },
            });
          }}
        >
          <img src={`/image-web/game/coupon.svg`} alt="쿠폰" />
          <span>COUPON</span>
        </div>
        <div
          className="button"
          onClick={() => {
            setGamePageState(GamePage.MY_PAGE);
          }}
        >
          <img src={`/image-web/game/my-profile.svg`} alt="마이페이지" />
          <span>MY</span>
        </div>
      </div>
    </GameHeaderWrapper>
  );
};
